<div class="nav-scroller bg-white shadow-sm">
    <nav class="nav nav-underline">
        <a class="nav-link" [routerLink]="['/user','counter', orgId]" routerLinkActive="active">
            <fa-icon [icon]="icons['faStopwatch20']"></fa-icon> {{'USER.MENU.counter' | translate}}
        </a>
        <a class="nav-link" [routerLink]="['/user','reservations', orgId]" routerLinkActive="active">
            <fa-icon [icon]="icons['faAddressCard']"></fa-icon> {{'USER.MENU.reservations' | translate}}
        </a>
        <a class="nav-link" [routerLink]="['/user','dynamic-data', orgId]" routerLinkActive="active">
            <fa-icon [icon]="icons['faStream']"></fa-icon> {{'USER.MENU.news' | translate}}
        </a>
        <a class="nav-link" [routerLink]="['/user','push-notification', orgId]" routerLinkActive="active">
            <fa-icon [icon]="icons['faBell']"></fa-icon> Push Notification
        </a>
        <a class="nav-link" [routerLink]="['/organization', orgId, 'informations']" routerLinkActive="active"
            *ngIf="accountType === 2">
            {{'ORGANIZATION.edit' | translate}} <fa-icon [icon]="icons['faArrowRight']"></fa-icon>
        </a>
    </nav>
</div>
